import { useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import { $isAuthorized, $userData } from '@@/auth/store/auth.store';
import { checkAuth } from '@@/auth/store/auth.store';
import { loadAndSetAgriculture } from '@@/agriculture/store/agriculture.store';
import { GLOBAL_EVENT_MANAGER } from '@/shared/api/event-manager';
import { offerExpiryEventHandler } from '@/modules/seller-account/functions/offer-expiry-event-handler.helper';
import { $singleBuyerData } from '@/modules/seller-account/store/buyers.store';
import { $buyersListSortState } from '@/modules/seller-account/store/sort.store';
import { debounce } from 'lodash-es';
import { setRecalculateStoreInProcess } from '@/widgets/recalculate-indicator/store/root.store';
import { notification } from 'antd';

export function useGlobalEffects() {
  const isAuthorized = useStore($isAuthorized);
  const userData = useStore($userData);

  const debouncedAction = debounce(async () => {
    await offerExpiryEventHandler();
  }, 500);

  const debouncedOfferUpdateAction = debounce(async (data) => {
    data.company &&
      notification.info({
        message: `Контрагент ${data.company} обновил параметры оффера №${data.id}`,
      });
    await offerExpiryEventHandler(data);
  }, 500);
  const debouncedPointUpdateAction = debounce(async (data) => {
    data.company &&
      notification.info({
        message: `Контрагент ${data.company} изменил параметры логистики`,
        duration: 0,
      });
  }, 500);

  useEffect(() => void checkAuth(), []);

  useEffect(() => {
    if (isAuthorized) loadAndSetAgriculture();
  }, [isAuthorized]);

  useEffect(() => {
    if (userData) {
      GLOBAL_EVENT_MANAGER.init(userData.id);
      GLOBAL_EVENT_MANAGER.listenOffersExpiryEvent({
        action: () => debouncedAction(),
      });
      GLOBAL_EVENT_MANAGER.listenOffersUpdateEvent({
        action: (data) => debouncedOfferUpdateAction(data),
      });
      GLOBAL_EVENT_MANAGER.listenPointUpdateEvent({
        action: (data) => debouncedPointUpdateAction(data),
      });
    }
  }, [userData]);
}
